import { flow, find, get } from 'lodash/fp'

export const findRoute = routes =>
  flow(
    find({ isIncoming: false }),
    get('routeId'),
  )(routes) || get('0.routeId')(routes)
